import { API_END_POINT, axiosInstance, SORT_KEYS } from '@app-store'
import {
  AddGeneralSettingsDataType,
  AddShiftDataType,
  PatchDataType,
  UpdateShiftDataType,
} from '../types/applicationPreferences.types'
import { isEmpty } from 'lodash'

export const addGeneralSettingsData = async (
  payload: AddGeneralSettingsDataType
) => {
  return await axiosInstance.post(
    `${API_END_POINT.CORE}v1/general-settings`,
    payload
  )
}

export const getGeneralSettingsData = async () => {
  return await axiosInstance.get(`${API_END_POINT.CORE}v1/general-settings`)
}
export const updateGeneralSettingsData = async (
  payload: AddGeneralSettingsDataType
) => {
  return await axiosInstance.put(
    `${API_END_POINT.CORE}v1/general-settings`,
    payload
  )
}

export const addShiftData = async (payload: AddShiftDataType) => {
  return await axiosInstance.post(
    `${API_END_POINT.CORE}v1/general-settings/shift`,
    payload
  )
}
export const getShiftsData = async (
  payload: {
    keyName: string
    direction: SORT_KEYS
    isAsc: SORT_KEYS
    key: string
  },
  rowsPerPage: number,
  page: number
) => {
  return await axiosInstance.get(
    `${API_END_POINT.CORE}v1/general-settings/shifts?page=${
      page - 1
    }&size=${rowsPerPage}`,
    {
      params: {
        sort: !isEmpty(payload?.keyName)
          ? `${payload?.keyName},${payload?.direction}`
          : undefined,
      },
    }
  )
}
export const updateShiftData = async (payload: UpdateShiftDataType) => {
  return await axiosInstance.put(
    `${API_END_POINT.CORE}v1/general-settings/shift`,
    payload
  )
}

export const patchShift = async (payload: PatchDataType) => {
  return await axiosInstance.patch(
    `${API_END_POINT.CORE}v1/general-settings/shift/${payload.id}?enabled=${payload.enabled}`,
    payload
  )
}
